import request from '../utils/request.js'

export default {
  // 获取流程模板列表
  getLists (params) {
    return request.post(`process_template/lists`, params).then(res => res.data)
  },
  // 获取模板详情
  getDetail (params) {
    return request.post(`process_template/detail`, params).then(res => res.data)
  },
  // 应用模板到项目
  applyToProject (params) {
    return request.post(`process_template/applyToProject`, params).then(res => res.data)
  },
  // 批量创建自定义流程
  createCustomProcess (params) {
    return request.post(`process_template/createCustomProcess`, params).then(res => res.data)
  },
  // 获取模板统计信息
  getStatistics (params) {
    return request.post(`process_template/statistics`, params).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/processTemplate.js